module.exports = __webpack_public_path__ + "img/button@2x.fb1715c4.png";